import { Navigate } from 'react-router-dom';

// Старый роут /profile теперь редиректит в раздел «Настройки → Профиль».
// Компания с её юр. лицами и адресами по-прежнему доступна
// по /company/:id и в карточке компании.
export const profile_routes = [
  {
    path: 'profile',
    element: <Navigate to="/settings/profile" replace />,
    loader: () => {
      return (document.title = 'Профиль');
    },
  },
];
